import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class GetCurrentPauseCoupon {
    apiService

    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    handle() {
        let apiUrl = ApiEndpoints['pause-coupon'];

        return this.apiService.get(apiUrl);
    }
}
